import AddResult from "./AddResult";

export default class AddFailResult extends AddResult {

    private _failMatrix: Array<any>;

    constructor(failMatrix = []) {

        super({});

        this.data.result = {};
        this.data.result.win = 0;
        this.data.result.totalWin = 0;

        // this.data.result.gameSpecifics = {};
        this.data.result.reelMatrix = [];
        this.data.result.reelMatrix[0] = failMatrix;

        this._failMatrix = failMatrix;

    }

    getFailMatrix() {
        return this._failMatrix;
    }

}